import type { ReactNode } from "react";

export interface EmptyStateProps {
  title: ReactNode;
  /** Mono helper line under the title. */
  hint?: ReactNode;
  /** Optional call-to-action (e.g. a Button). */
  action?: ReactNode;
}

/** The POC's dashed `.empty` placeholder box. */
export function EmptyState({ title, hint, action }: EmptyStateProps) {
  return (
    <div className="empty">
      <strong>{title}</strong>
      {hint != null && <span className="sub">{hint}</span>}
      {action != null && <div className="empty-action">{action}</div>}
    </div>
  );
}
